const validateDiscussion = function ({ commit, state }) {
  commit("VALIDATE_DISCUSSION");

  return Promise.resolve(state.submissionErrors);
};

export default validateDiscussion;
